import axios from 'index/axios'

// 查询当前用户在项目中的角色
export function getMyRole(projectId) {
    return axios.get(`/QcReview/myRole/${projectId}`)
}

// 取店池（兼职QC用）
export function getQcPool(params) {
    return axios.post('/QcReview/pool', params)
}

// 待分配池（内部QC用）
export function getQcPending(params) {
    return axios.post('/QcReview/pending', params)
}

// 兼职QC取店
export function claimDealers(params) {
    return axios.post('/QcReview/claim', params)
}

// 兼职QC释放门店
export function releaseDealers(params) {
    return axios.post('/QcReview/release', params)
}

// 内部QC指派门店
export function assignDealers(params) {
    return axios.post('/QcReview/assign', params)
}

// 内部QC驳回门店
export function rejectDealers(params) {
    return axios.post('/QcReview/reject', params)
}
